var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMysubscriptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{\r\n                fill:#9384be;\r\n            }\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.62,160A15.64,15.64,0,0,1,0,144.38V15.62A15.64,15.64,0,0,1,15.62,0H144.38A15.64,15.64,0,0,1,160,15.62V66.27a4.47,4.47,0,0,1-8.93,0V15.62a6.7,6.7,0,0,0-6.69-6.69H15.62a6.7,6.7,0,0,0-6.69,6.69V144.38a6.7,6.7,0,0,0,6.69,6.69h9.45a4.47,4.47,0,0,1,0,8.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.07,160a4.47,4.47,0,1,1,0-8.93h41.2a4.47,4.47,0,0,1,0,8.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.47,50.13a4.47,4.47,0,1,1,0-8.93H155.53a4.47,4.47,0,1,1,0,8.93Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.93,
    cy: 25.07,
    r: 4.47,
    transform: "translate(2.11 52.61) rotate(-80.85)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 52.53,
    cy: 25.07,
    r: 4.47,
    transform: "translate(9.16 63.88) rotate(-67.33)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 73.13,
    cy: 25.07,
    r: 4.47,
    transform: "translate(21.82 82.89) rotate(-67.33)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.33,160A45.67,45.67,0,1,1,160,114.33,45.72,45.72,0,0,1,114.33,160Zm0-82.4a36.74,36.74,0,1,0,36.74,36.73A36.78,36.78,0,0,0,114.33,77.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.37,111.93A10.91,10.91,0,0,1,27.47,101V72.7a10.92,10.92,0,0,1,10.9-10.9H80a4.47,4.47,0,1,1,0,8.93H38.37a2.4,2.4,0,0,0-1.71.72A2.37,2.37,0,0,0,36,73.17l.43,27.9a2.39,2.39,0,0,0,2.4,2.36L52.61,103a4.47,4.47,0,0,1-.08,8.93Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.93,132.53a4.47,4.47,0,0,1,0-8.93h20.6a4.47,4.47,0,1,1,0,8.93Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.16,129.1a4.4,4.4,0,0,1-3.11-1.27l-10.57-10.3a4.44,4.44,0,0,1-.07-6.31,4.39,4.39,0,0,1,3.18-1.33,4.45,4.45,0,0,1,3.13,1.27l5.2,5.06a2.39,2.39,0,0,0,1.68.68h.13a2.4,2.4,0,0,0,1.73-.88l12.15-14.82a4.47,4.47,0,0,1,3.46-1.63,4.39,4.39,0,0,1,2.83,1,4.47,4.47,0,0,1,.61,6.29l-16.89,20.6a4.52,4.52,0,0,1-3.21,1.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysubscriptions);
export default __webpack_public_path__ + "static/media/my subscriptions.5be8245cd3afcee4f2a3a661a14c1675.svg";
export { ForwardRef as ReactComponent };